import React from 'react'

const IconCheck = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='12'
      viewBox='0 0 16 12'
      fill='none'
    >
      <path
        d='M6.10647 10.558L1.41406 5.86562L2.15141 5.12827L6.10647 9.08288L13.1898 2L13.9272 2.73735L6.10647 10.558Z'
        fill='#38C278'
        stroke='#38C278'
        strokeWidth='2'
      />
    </svg>
  )
}

export default IconCheck
